export const TEMPLATE_TYPES = {
  NODE: "node",
  EDGE: "edge"
}